<template>
  <div>
    <div style="text-align: left; width: 100%; display: flex; flex-direction: row;">
      <el-select 
          size="small"
          @change="loadData"
          v-model="store_id" 
          filterable 
          placeholder="Select store..."
          style="width: 150px; text-align: left;">
          <el-option 
            :label="''" 
            :value="-1">
            <span style="float: left" v-html="''"></span>
          </el-option>
          <el-option
              v-for="(data, index) in $store.getters.getAccessibleStoreList"
              :key="index"
              :label="data.store_name"
              :value="data.id">
              <span style="float: left" v-html="data.store_name"></span>
          </el-option>
      </el-select>
      <el-button @click="loadData" style="margin-left: 10px;" size="small" type="primary">
        Search
      </el-button>
    </div>
    <div v-if="!production_calendar" style="text-align: left; width: 100%; margin-top: 20px; margin-bottom: 0px;">
      <el-tag style="margin: 2px;" size="small" type="success" effect="dark">
          DELIVERIES
      </el-tag>
      <el-tag style="margin: 2px;" size="small" type="warning" effect="dark">
          TRIALS
      </el-tag>
      <el-tag style="margin: 2px;" size="small" type="danger" effect="dark">
          TASKS
      </el-tag>
    </div>
    <div v-else style="text-align: left; width: 100%; margin-top: 20px; margin-bottom: 0px;">
      <el-tag 
          v-for="(data, index) in getItemCategory" 
          :key="index" 
          :style="{margin: '2px', color: 'white', backgroundColor: data.color}" size="small" effect="plain">
          {{data.category_name}}
      </el-tag>      
    </div>
    <el-calendar v-model="value">
  <!-- Use 2.5 slot syntax. If you use Vue 2.6, please use new slot syntax-->
      <template
        slot="dateCell"
        slot-scope="{date, data}">
        <div :class="data.isSelected ? 'is-selected' : ''" style="display: flex; flex-direction: column;">
          <span>{{ data.day.split('-').slice(2)[0] }}</span>
          <div v-if="$store.getters.getTaskCalendar.filter(t => t.date == data.day).length>0 && !production_calendar" style="flex-direction: row; display: flex; justify-content: center; align-items: center;">
            <el-tag style="margin: 2px;" size="small" type="success" effect="dark" v-if="$store.getters.getTaskCalendar.filter(t => t.date == data.day)[0].total_deliveries>0">
                {{$store.getters.getTaskCalendar.filter(t => t.date == data.day)[0].total_deliveries>0 ? $store.getters.getTaskCalendar.filter(t => t.date == data.day)[0].total_deliveries : ''}}
            </el-tag>
            <el-tag style="margin: 2px;" size="small" type="warning" effect="dark" v-if="$store.getters.getTaskCalendar.filter(t => t.date == data.day)[0].total_trials>0">
                {{$store.getters.getTaskCalendar.filter(t => t.date == data.day)[0].total_trials>0 ? $store.getters.getTaskCalendar.filter(t => t.date == data.day)[0].total_trials : ''}}
            </el-tag>
            <el-tag style="margin: 2px;" size="small" type="danger" effect="dark" v-if="$store.getters.getTaskCalendar.filter(t => t.date == data.day)[0].total_tasks>0">
                {{$store.getters.getTaskCalendar.filter(t => t.date == data.day)[0].total_tasks>0 ? $store.getters.getTaskCalendar.filter(t => t.date == data.day)[0].total_tasks : ''}}
            </el-tag>
          </div>
          <div 
            v-else-if="getPlannerDataList.length>0 && getFinalFutureList.filter(t => t.date == data.day).length>0 && production_calendar"
            style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: center; align-items: center;">

              <div 
                v-for="(data1, index) in getItemCategory" 
                :key="index">
                  <el-tag 
                      :style="{margin: '2px', color: 'white', backgroundColor: data1.color}" 
                      size="small" 
                      effect="plain" 
                      v-if="getFinalFutureList.filter(t => t.date == data.day)[0].category_list.filter(t => t.id == data1.id).length > 0">
                      {{getFinalFutureList.filter(t => t.date == data.day)[0].category_list.filter(t => t.id == data1.id)[0].qty}}
                  </el-tag>
              </div>
          </div>
          
        </div>
      </template>
    </el-calendar>

    <el-dialog
        v-if="show_appointment"
        :title="getSelectedDate[0]"
        width="450px"
        :visible.sync="show_appointment"
        append-to-body>
            <Appointments 
                :store_id="store_id"
                :selected_date="getSelectedDate[2]"
                @closed="loadCalendar"
                @loadCalendar="loadCalendar"/>
    </el-dialog>

    <el-dialog
        v-if="show_planner_window"
        :title="getSelectedDate[0]"
        fullscreen
        :visible.sync="show_planner_window"
        append-to-body>
            <CustomerList 
                :calendar_view="true"
                :searchType="1" 
                :data_list="planner_data_list"/>
    </el-dialog>
    
  </div>
</template>

<script>
import Appointments from './Appointments.vue'
import CustomerList from '../../views/Planner/CustomerList/Index.vue'

export default {
  props: ['production_calendar'],
  components: {Appointments, CustomerList},
  data() {
    return {
      store_id: null,
      value: new Date(),
      show_appointment: false,
      month_number: '',
      old_month_number: '',
      do_not_show_appointment: false,
      showQuickView: false,
      planner_data_list: [],
      show_planner_window: false,
      colors: ['#a32cc4', '#7a4988', '#a1045a', '#311432', '#630436', '#e2bdf0', '#ff00ff', '#957a81']
    }
  },
  computed: {
      getItemCategory() {
          let list = JSON.parse(JSON.stringify(this.$store.getters.getItemCategoryList))

          let returnList = []

          let index = 0
          list.forEach(element => {
              element.color = this.colors[index]
              index ++

              returnList.push(element)
          })

          return returnList
      },
      getPlannerDataList() {
          if(this.$store.getters.getPlannerList !== null) {
            return JSON.parse(JSON.stringify(this.$store.getters.getPlannerList.future_orders))
          }
          return []
          
      },
      getFailedList() {
          return this.getPlannerDataList.filter(t => t.failed)
      },
      getFutureList() {
          return this.getPlannerDataList.filter(t => !t.failed)
      },
      getCommonPlannerData() {
        let returnList = []

        this.getFailedList.forEach(element => {
            if(this.getFutureList[0]) {
                element.appointment_date = this.getFutureList[0].current_date
                returnList.push(element)
            }            
        })

        this.getFutureList.forEach(element => {
            returnList.push(element)
        })

        return returnList
      },
      getFinalFutureList() {
          let returnList = []
          if(this.getPlannerDataList.length>0) {
            
              let list = this.getCommonPlannerData.filter((thing, index, self) =>
                  index === self.findIndex((t) => (t.appointment_date === thing.appointment_date))
              )
              /*** ALL FUTURE ***/

              list.forEach(element => {
                  
                  let newElement = {
                      date: element.appointment_date,
                      data_list: this.getCommonPlannerData.filter(t => t.appointment_date === element.appointment_date),
                      category_list: []              
                  }

                  let categoryList = []
                  this.getItemCategory.forEach(category => {

                      let categoryFilter = this.getCommonPlannerData.filter(t => (t.category_id === category.id || t.sub_template_category_id === category.id) && t.appointment_date === element.appointment_date)
                      if(categoryFilter.length>0) {
                          
                          categoryList.push({
                            id: category.id,
                            qty: categoryFilter.length,
                            color: category.color
                          })
                          
                      }
                  })
                  newElement.category_list = categoryList
                  returnList.push(newElement)
                                
              })
          }
          return returnList
      },
      getCurrentMonthTab() {
        return this.month_number
      },
      getCurrentMonth() {
          return (this.value.getUTCMonth()+1)
      },
      getSelectedDate() {

        let date = new Date(this.value)

        let month = date.getMonth()

        let day = date.getDate()
        if(day<10) {
          day = '0'+day
        }
        let year = date.getFullYear()

        let monthIndex = (month+1)
        if(monthIndex<10) {
          monthIndex = '0'+monthIndex
        }
        return [this.masterMonths[month].name+' '+day+' '+year, date, year+'-'+monthIndex+'-'+day]
      }
  },
  methods: {
      loadData() {
          if(this.production_calendar) {
            this.productionLoad()
          } else {
            this.loadCalendar()
          }
      },
      productionLoad() {

          this.$store.state.production.nav.multi_store_search = false
          this.$store.state.production.nav.store_list = []
          this.$store.state.production.nav.pending_approval = false
          this.$store.state.production.nav.custom_batch = false
          this.$store.state.production.nav.process_id = 0
          this.$store.state.production.nav.workshop_id = this.store_id
          this.$store.state.production.nav.store_id = 0
          this.$store.state.production.nav.planner = true
                    
          this.$store.state.production.nav.include_hidden_process = false
          this.$store.state.production.nav.store_query = true

          this.$store.dispatch('fetchProductionWorkOrderList', this.$store.state.production.nav)
      },
      loadCalendar() {
        this.$store.dispatch('fetchMonthlyAppointments', 
        {
          selected_month: this.getCurrentMonth, 
          store_id: this.store_id
        })
      },
      dateChanged($event) {
        if(!this.do_not_show_appointment) {
          if(this.production_calendar) {            
            let date = $event[2]
            
            let list = this.getFinalFutureList.filter(t => t.date == date)[0]
            this.planner_data_list = list.data_list

            setTimeout(() => {
              this.show_planner_window = true            
            }, 300);
          } else {
            this.show_appointment = true
          }
          
        }
        
      },
  },
  mounted() {
      this.$store.dispatch('fetchTaskCategoryList')
      this.$store.dispatch('fetchPreferences')
      this.$store.dispatch('fetchProductionStageList')
      this.$store.dispatch('fetchItemCategoryList', {type: 0})
      this.$store.dispatch('fetchEmployeeMasterList', {store_list: this.$store.getters.getAccessibleStoreList})        
      setTimeout(() => {
        if(this.$store.getters.getAccessibleStoreList.length>0) {
          this.store_id = this.$store.getters.getAccessibleStoreList[0].id
          
          this.loadData()
        }        
      }, 1000);
  },
  watch: {
      getCurrentMonth(newValue) {
          this.month_number = newValue+''
          if(this.month_number != this.old_month_number) {
              this.do_not_show_appointment = true
          }
          this.loadData()
      },
      getSelectedDate(newValue) {
          let currentMonth = (new Date(newValue[1]).getMonth()+1)
          if(this.old_month_number == currentMonth) {
              this.do_not_show_appointment = false
          } else {
            this.old_month_number = currentMonth
          }
          this.dateChanged(newValue)
      },
  }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/TaskCalendar/Index.vue